import { render, staticRenderFns } from "./AccountCertificateFormDriving.vue?vue&type=template&id=06457614&scoped=true&"
import script from "./AccountCertificateFormDriving.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormDriving.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormDriving.vue?vue&type=style&index=0&id=06457614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06457614",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
